class CartDrawer extends HTMLElement {
  constructor() {
    super();
this.ticoObserver = new MutationObserver(() => {
  const drawer = this.querySelector('#CartDrawer');
  if (!drawer) return;

  const hasD80 = [...drawer.querySelectorAll('tr.cart-item')].some(item => {
    const link = item.querySelector('a.cart-item__name');
    return link?.getAttribute('href')?.includes('haotian-rotary-attachments') &&
      [...item.querySelectorAll('dd')].some(dd => dd.textContent.trim() === 'D80');
  });

  if (hasD80 && !drawer.querySelector('.tico-jawflex-recommendation')) {
    this.showTicoJawFlex();
  }
});

this.ticoObserver.observe(this, {
  childList: true,
  subtree: true
});
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
      this.showTicoJawFlex();
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      this.showTicoJawFlex();
    });
  }
  showTicoJawFlex() {
    const drawer = document.querySelector('#CartDrawer');
    if (!drawer) return;

    drawer.querySelectorAll('.tico-jawflex-recommendation')
      .forEach(card => card.remove());

    const items = drawer.querySelectorAll('tr.cart-item');

    items.forEach(item => {
      const productLink = item.querySelector('a.cart-item__name');
      if (!productLink) return;

      const isRotary = productLink.getAttribute('href')?.includes('haotian-rotary-attachments');
      const isD80 = Array.from(item.querySelectorAll('dd'))
        .some(option => option.textContent.trim() === 'D80');

      if (!isRotary || !isD80) return;

      const recommendation = document.createElement('tr');
      recommendation.className = 'tico-jawflex-recommendation';

recommendation.innerHTML = `
  <td colspan="4" style="padding:12px 0 18px;">
    <a href="https://ticolaser.com/product/tl-jaw-flex-d80-rotary-upgrade-system/"
       target="_blank"
       rel="noopener noreferrer"
       style="display:block;padding:8px 10px;border:1px solid #ddd;border-left:4px solid #b63232;border-radius:9px;background:#fff;text-align:center;text-decoration:none;color:#222;">

      <div style="font-size:16px;font-weight:700;margin-bottom:5px;">
        Get More From Your D80
      </div>

      <div style="font-size:13px;line-height:1.4;margin-bottom:4px;">
        Upgrade your D80 rotary with TL Jaw Flex™.
      </div>

      <div style="font-size:13px;font-weight:700;color:#b63232;text-decoration:underline;margin-bottom:2px;">
        Explore the Jaw Flex Upgrade ↗
      </div>

      <img
        src="https://cdn.shopify.com/s/files/1/0631/2253/8680/files/TL_Jaw_Flex2.png?v=1791680160"
        alt="TL Jaw Flex D80 Rotary Upgrade"
       display:block;width:92%;height:auto;max-width:100%;object-fit:contain;border-radius:4px;margin:0 auto;
      >

      <div style="font-size:10px;line-height:1.4;color:#777;margin-top:2px;white-space:nowrap;">
        Sold separately by our partner
        <span style="color:#b63232;font-weight:700;">Tico Laser</span>
        • Opens in a new tab
      </div>

    </a>
  </td>
`;
   item.parentElement.appendChild(recommendation); 
    });
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
